import { get, post } from '@/services/request';

interface LoginResponse {
  code: number;
  msg: string;
  traceId: string;
  data?: {
    token: string;
    roleType: number;
    subRoleTypes: number[];
  };
}

export interface UserInfoData {
  id?: string;
  name?: string;
  username?: string;
  avatar?: string;
  email?: string;
  address?: string;
  phone?: string;
  access?: string;
  roleType?: number;
  subRoleTypes?: number[];
  [key: string]: unknown;
}

interface UserInfoResponse {
  code: number;
  msg: string;
  traceId: string;
  data?: UserInfoData;
}

export const login = (data: any) => {
  return post<LoginResponse>('/passport/login', data);
};

export const sendSms = (data: { phone: string }) => {
  return post<{
    code: number;
    msg: string;
    traceId: string;
    data?: {
      codeKey?: string;
    };
  }>('/passport/sendSms', data);
};

export const loginSms = (data: { phone: string; code: string; codeKey?: string }) => {
  return post<LoginResponse>('/passport/loginSms', data);
};

export const getUserInfo = () => {
  return post<UserInfoResponse>('/passport/userInfo');
};
